import PropTypes from 'prop-types';

import React from 'react';

class ConstraintAlertField extends React.Component {
  static propTypes = {
    displayOptions: PropTypes.object,
    max: PropTypes.number,
    min: PropTypes.number,
    value: PropTypes.any,
  };

  render() {
    let val = this.props.value;

    if (this.props.displayOptions && this.props.displayOptions[val]) {
      val = this.props.displayOptions[val];
    }

    let symbol;

    if (this.props.value !== null && this.props.value !== undefined && this.props.value !== '' && this.props.value !== 'Not Tested' &&
        this.props.min && this.props.max) {
      symbol = <i className='icon-bad bl bl-attention' />;
    }
    if (this.props.value !== null && this.props.value !== undefined && this.props.value !== '' && this.props.value !== 'Not Tested' &&
        this.props.value >= this.props.min && this.props.value <= this.props.max) {
      symbol = <i className='icon-good bl bl-checkmark_circle' />;
    }
    return (
      <div className='form-control-static'>
        { val } &nbsp; { symbol }
      </div>
    );
  }
}

export default ConstraintAlertField;
